import { render, staticRenderFns } from "./IssueSummaryWidget.vue?vue&type=template&id=620839c8&"
import script from "./IssueSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./IssueSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports